import { Loading } from '@/components/Loading';
import type React from 'react';
import styles from './index.module.scss';

export type GoalProps = {
  goal: string | null | undefined;
  isSummarized: boolean;
  onOpenModal: () => void;
  overwriteBlockReason: string | null | undefined;
};

export const Goal: React.FC<GoalProps> = ({
  goal,
  isSummarized,
  onOpenModal,
  overwriteBlockReason,
}) => {
  return (
    <div>
      <div className={styles.mainContent}>
        <div className={styles.header}>
          <h3 className={styles.label}>あなたの学習目標</h3>
          {isSummarized && (
            <button
              type="button"
              onClick={onOpenModal}
              disabled={!!overwriteBlockReason}
            >
              目標を編集する
            </button>
          )}
        </div>
        {!isSummarized ? (
          <div className={styles.loadingContainer}>
            <Loading />
          </div>
        ) : (
          goal && <p className={styles.goalText}>{goal}</p>
        )}
      </div>
      {isSummarized && overwriteBlockReason && (
        <p className={styles.annotation}>{overwriteBlockReason}</p>
      )}
    </div>
  );
};
